<template>
  <Form
    ref="queryForm"
    class="form-flex label-hide opacity"
    label-position="left"
    :label-width="80"
    :model="queryModel"
    :rules="rules"
    @submit.native.prevent
  >
  <h2>旅平險</h2>
    <GroupRadio v-model="queryModel.abroad" type="button" label="旅遊地區" :radios="radios" />
    <DateTimePickerInput v-model="queryModel.startTime" label="出發時間" prop="startTime" />
    <DateTimePickerInput
      v-model="queryModel.endTime"
      :disabled-hours="endDisabledHours"
      :disabled="isEmpty.start"
      :options="endTimeOptions"
      label="結束時間"
      prop="endTime"
    />
    <BaseVueSelect
      v-model="queryModel.expectPremium"
      label="期望保額"
      prop="expectPremium"
      :options="options"
    />
    <div class="form-footer clearfix mb-s">
      <span
        v-if="totalDays"
        class="tips-primary"
        :style="{lineHeight: '38px'}"
        v-text="`您的旅遊天數共 ${totalDays} 天`"
      />
      <Button
        class="pull-right btn-primary btn-m btn-shadow"
        :loading="loading"
        @click="handleSubmit"
      >
        <span v-if="!loading">快速試算保費</span>
        <span v-else>請稍候</span>
      </Button>
    </div>
    <div class="notice">
      <p>* 一天以24小時計算，旅遊天數至少1天。</p>
      <p>* 合適保額為年薪的10倍，目前保額最高為1000萬。</p>
      <p>* 依據法令規定欲投保兩人以上或未滿20歲者申請投保，請洽專員辦理 。</p>
    </div>
  </Form>
</template>

<script>
//import axios, { generateAuthPostConf  } from '@/utils/axios';
// date-fns
import differenceInCalendarDays from "date-fns/difference_in_calendar_days";
import differenceInHours from "date-fns/difference_in_hours";
import getTime from "date-fns/get_time";
// component
import { Form, Button } from "iview";
import GroupRadio from "@/components/forms/elements/GroupRadio";
import DateTimePickerInput from "@/components/forms/elements/DateTimePickerInput";
import BaseVueSelect from "@/components/forms/elements/BaseVueSelect";
// options & radios
import { abroad as radios } from "@/staticData/radios";
// default model
import {
  travelModel,
  travelRules,
  options
} from "@/utils/asyncValidator/queryForms";
//import Cookies from 'js-cookie';
export default {
  components: {
    Form,
    Button,
    GroupRadio,
    DateTimePickerInput,
    BaseVueSelect
  },
  props: {
    model: {
      type: Object,
      default: () => travelModel
    },
    carno: {
        type: String,
        default() {
          //console.log(this.carno);
          return this.carno ==null?null:this.carno;
        }
      },
    loading: {
      type: Boolean,
      default: false
    },
    handleQuery: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    const startTimeValidator = (rule, value, callback) => {
      const { date, time } = value;
      const diffter = differenceInHours(`${date} ${time}`, new Date());
      //const diffter = new Date(`${date} ${time}`) - new Date();
      let errorMsg = [];
      if (!date) {
        //errorMsg.push("請選擇您旅遊的出發日期");
        return callback(new Error("請選擇您旅遊的出發日期"));
      }
      if (!time) {
        //errorMsg.push("請選擇您旅遊的出發時間");
        return callback(new Error("請選擇您旅遊的出發時間"));
      }
      //console.log(diffter);
      if (diffter < 1) {
        //Wen Add 2019/11/28 控制無法選擇過去的時間點
       // console.log(`${date} ${time}`);
        //console.log("InsuTravelQueryForm" + diffter);
        //errorMsg.push("出發時間需大於目前時間1小時");
        return callback(new Error("出發時間需大於目前時間1小時"));
      }
      callback();
    };
    const endTimeValidator = (rule, value, callback) => {
      if (this.isEmpty.end) return callback(new Error("請選擇您的結束時間"));
      const {
        queryModel: { endTime, startTime }
      } = this;
      const sDateStr = `${startTime.date} ${startTime.time}`;
      const eDateStr = `${endTime.date} ${endTime.time}`;
      const diffHours = differenceInHours(eDateStr, sDateStr);
      //const diffter = differenceInHours(sDateStr, new Date());
      //if (diffter < 1) return callback(new Error("出發時間需大於目前時間1小時"));//Wen Add 2019/11/28 控制無法選擇過去的時間點
      if (diffHours < 24) return callback(new Error("投保總時數需大於24小時"));
      callback();
    };
    const rules = {
      ...travelRules,
      endTime: { validator: endTimeValidator, trigger: "validate" },
      startTime: { validator: startTimeValidator, trigger: "validate" }
    };
    const queryModel = this.$cloneDeep(this.model);
   
//    console.log("queryModel.carNo0:"+this.carno);
//console.log("queryModel.carNo3:"+this.carno);
    return {
      queryModel,
      endTimeOptions: {
        disabledDate: currDate => {
          const { queryModel, isEmpty } = this;
          if (isEmpty.start) return;
          return (
            currDate.valueOf() < getTime(queryModel.startTime.date) + 86400
          );
        }
      },
      endDisabledHours: false,
      options: options.expectPremium.travel,
      rules,
      radios
    };
  },
  watch: {
    "queryModel.startTime"() {
      const {
        queryModel: { startTime, endTime }
      } = this;
      if (startTime.time) {
        endTime.time = startTime.time;
        this.endDisabledHours = true;
      } else {
        this.endDisabledHours = false;
      }
    }
  },
  computed: {
    isEmpty() {
      const { startTime, endTime } = this.queryModel;
      return {
        start: Object.values(startTime).some(val => !val),
        end: Object.values(endTime).some(val => !val)
      };
    },
    totalDays() {
      const {
        isEmpty,
        queryModel: { startTime, endTime }
      } = this;
      const isSelectBoth = Object.values(isEmpty).every(val => val === false);
      if (!isSelectBoth) return null;
      const day = differenceInCalendarDays(endTime.date, startTime.date);
      return endTime.time > startTime.time ? day + 1 : day;
    },
    premiumLabel() {
      const {
        queryModel: { expectPremium },
        options
      } = this;
      if (!expectPremium) return null;
      const { label } = options.find(option => option.value === expectPremium);
      return label;
    },
    disabledHours() {
      const {
        queryModel: { endTime, startTime },
        isEmpty
      } = this;
      if (isEmpty.start) return [];
      const diffDays = differenceInCalendarDays(endTime.date, startTime.date);
      if (diffDays !== 1) return [];
      const [hours] = startTime.time.split(":");
      return Array.from({ length: parseInt(hours, 10) }, (x, i) => i);
    }
  },
  methods: {
    validate() {
      return this.$refs.queryForm.validate(v => v);
    },
    async handleSubmit() {
      const isValid = await this.validate();
      if (!isValid) return;
      const { queryModel, totalDays, premiumLabel } = this;
      const type = "travel";
      const tips = { totalDays, premiumLabel };
      this.handleQuery({ type, tips, ...queryModel });
    },
    async initPartner() {       
        /*const  orderId  =this.queryModel.codeid;  
        
        const { queryModel: { carNo }} = this;  //旅平險carno是token
        //console.log("orderId"+orderId);
        const config = generateAuthPostConf('api/tokenVerify', { orderId });
        const { data } = await axios(config);
        const { reviews } = data.result;   
        //console.log("insuTravelQueryForm-carno"+JSON.stringify( this.Carno));     
        this.Carno=queryModel.carNo; */   
        /*this.details = data.result;
        this.insuInfo=this.details[0];
        this.carProfile.carNo = this.details[0].carNo;
        this.type=this.carProfile.carNo.carType;
        this.red_url+=this.type+"/"+this.carProfile.carNo.block1+"-"+this.carProfile.carNo.block2;*/  //
       // console.log("insuTravelQueryForm-carno2"+JSON.stringify( this.Carno));     
                
      }
  }
};
</script>
